export default __webpack_public_path__ + "static/media/Warlord's Mace.1069e1e1.jpg";